import * as React from "react"
import { cn } from "@/lib/utils"

export interface BitcoinLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Size of the logo in pixels
   * @default 24
   */
  size?: number
}

/**
 * Bitcoin logo component
 *
 * Displays the Bitcoin cryptocurrency logo.
 *
 * @example
 * ```tsx
 * <BitcoinLogo />
 * <BitcoinLogo size={32} />
 * <BitcoinLogo className="opacity-75" />
 * ```
 */
export const BitcoinLogo = React.forwardRef<HTMLImageElement, BitcoinLogoProps>(
  ({ size = 24, className, style, alt = "Bitcoin", ...props }, ref) => {
    return (
      <img
        ref={ref}
        src="/icons/bitcoin.svg"
        alt={alt}
        className={cn("inline-block", className)}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          ...style
        }}
        {...props}
      />
    )
  }
)

BitcoinLogo.displayName = "BitcoinLogo"